import store from '../../store'

/** getState proxy allows for mocking in tests */
export function getState () {
  return store.getState()
}
